import { useTranslation } from 'react-i18next';
import { useQtDetails } from '../queries';

export interface UseRetirementAccountsSummaryProportionChartArgs {
  householdID: string | undefined | null;
}

export function useRetirementAccountsSummaryProportionChart({
  householdID,
}: UseRetirementAccountsSummaryProportionChartArgs) {
  const { t: tUI } = useTranslation('UI');
  const { qtDetails } = useQtDetails({
    householdID,
    includeTotalOther: true,
    includeTotalEducation: true,
    includeTotalHealthcare: true,
    // Needed to decide whether to show these buckets at all: presence of an
    // account, not a non-zero balance. A $0 529 still gets an Education row.
    includeEducationAccounts: true,
    includeHealthcareAccounts: true,
    includeTotalTaxFree: true,
    includeTotalTaxDeferred: true,
    includeTotalRetirementAssets: true,
  });

  return { qtDetails, tUI };
}
